import {isAfter, isBefore} from 'date-fns';

export function isEnabledDateRange(dateRange: [Date, Date], minDate?: Date, maxDate?: Date) {
  return !(
    (minDate && isBefore(dateRange[0], minDate)) ||
    (maxDate && isAfter(dateRange[1], maxDate))
  );
}
